module.exports = __webpack_public_path__ + "img/web-template.f6aee879.jpg";